<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-building page-icon"></i>
			</div>

			<div>
				<div class="text-center">LISTA</div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2 disabled"><i class="fa fa-lg mb-2 fa-search"></i><br />Szűrő</button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<!--
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button>
				</div>
				-->
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<div class="float-end pt-4">
							<div class="row g-2">
								<div class="col-auto" style="width:300px;">
									<div class="input-group">
										<input type="text" class="form-control" id="text-search" placeholder="Keresés..." oninput="Anvil.page.quickSearch()" />
										<span class="input-group-text"><i class="fa fa-search"></i></span>
									</div>
								</div>
							</div>
						</div>

						<h2>NTAK Hibanapló (<%= db_name %>)</h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Order</li>
							<li class="breadcrumb-item active">NTAK Hibanapló</li>
						</ol>
					</div>

					<%- include('/ui/grid', {
						name: 'error_log',
						params: {
							row_height: 36,
							/*
							row_class: (row) => {
								const terminal = Anvil.page.terminals.getByMachineId(row.hardware_uuid)
								if (terminal && terminal.sandbox) return 'bg-body-secondary text-dim'
								if (row.message.match(/ECONNRESET|ENOTFOUND|ETIMEDOUT|ECONNABORTED/i)) return 'bg-body-secondary text-primary'
								if (row.message.match(/ACEC\_|MSACSRV|PC-AEE|Külső kijelző csatlakozási hiba/i)) return 'bg-body-secondary text-warning'
								if (row.message.match(/ER_LOCK_DEADLOCK|ER_LOCK_WAIT_TIMEOUT|ER_OUT_OF_SORTMEMORY/i)) return 'bg-danger text-light'
								return ''
							},
							*/
							columns: [
								{
									title: 'Bizonylat azonosító',
									field: 'uuid',
									type: 'string',
									options: {
										cutoff: 64
									},
									width: 280
								},
								{
									title: 'Bizonylat kiállítva',
									field: 'receipt_dt',
									type: 'datetime',
									width: 180
								},
								{
									title: 'Hiba leírása',
									field: 'state_message',
									type: {
										render (value, row, options) {
											return [...new Set(JSON.parse(value).map(err => `${err.hibaUzenet} (mező: ${err.mezoNeve.split('.').pop()})`))].join(', ')
										}
									},
									width: 800
								},
								{
									title: 'Műveletek',
									field: 'uuid',
									type: {
										render (value, row, options) {
											return `<button class="btn btn-sm btn-danger" onclick="Anvil.page.manual_fix('${value}')"><i class="fa fa-fw fa-wrench me-2"></i>Kézi javítás bejegyzése</button> <button class="btn btn-sm btn-warning" onclick="Anvil.page.resend('${value}')"><i class="fa fa-fw fa-redo-alt me-2"></i>Újraküldés</button>`
										}
									},
									width: 320
								}
							]
						},
						list: error_log
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-fw fa-edit"></i><span class="d-none d-md-inline ms-2">Megnyitás</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	quickSearch () {
		/*
		const filters = []
		if (Anvil.page.search.machine_id) {
			filters.push(row => row.hardware_uuid == Anvil.page.search.machine_id)
		}

		const expression = $('#text-search').val()

		Anvil.models.components.Grid.find('#error_log_grid').filter(expression, filters)
		*/
	},

	async manual_fix (receipt_uuid) {
		await Anvil.exec('c_order/error_log/action_manual_fix_ntak_order_summary', Anvil.page.db_name, receipt_uuid)
	},

	async resend (receipt_uuid) {
		await Anvil.exec('c_order/error_log/action_resend_ntak_order_summary', Anvil.page.db_name, receipt_uuid)
	},

	refresh () {
		Anvil.exec('c_order/error_log/action_refresh_ntak_error_list', Anvil.page.db_name)
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#error_log_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('c_order/error_log/modal_ntak_error_details', Anvil.page.db_name, sel[0].uuid)
		}
	}
})

$('#error_log_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
